import styled from 'styled-components';
import { COLOR_DARKER_GREY } from '../../assets/styles/colors';
import { BP_MOBILE_MAX } from '../../assets/styles/breakpoints';

export default styled.div`
  display: flex;
  width: 100vw;
  height: 100vh;
  min-height: 800px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${COLOR_DARKER_GREY};
  padding: 0 20px;
  .form-wrap {
    background: white;
    padding: 40px 40px;
    border-radius: 13px;
    max-width: 600px;
  }
  .forgot-password {
    margin-top: 20px;
  }
  .logo-wrap {
    max-width: 600px;
    width: 100%;
    text-align: center;
    margin-bottom: 40px;
    svg {
      width: 80%;
      height: auto;
      max-width: 250px;
    }
  }
  @media (max-width: ${BP_MOBILE_MAX}px) {
    .form-wrap {
      background: white;
      padding: 20px 20px;
      border-radius: 13px;
      max-width: 600px;
    }
  }
`;
